module.exports = __webpack_public_path__ + "7c0f641a1aeb76ea574bbb226dd7b303.fbx";